export enum EncounterType {
  PHYSICAL = 'physical',
  ENCOUNTER = 'encounter',
  WELL_WOMAN = 'well-woman',
  PRE_CONCEPTION = 'pre-conception',
  ANTEPARTUM = 'antepartum',
  POSTPARTUM = 'postpartum',
  BIRTHING_CENTER_ADMISSION = 'birthing-center-admission',
  ULTRASOUND = 'ultrasound',
}
